"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return _extendStatics(d, b);
  };
  return function (d, b) {
    _extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Header = void 0;
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var classnames_1 = require("../util/classnames");
var vdl_prefix_1 = require("../util/vdl-prefix");
var arrow_circle_right_1 = __importDefault(require("adp-react-icons/lib/fa/arrow-circle-right"));
var arrow_circle_left_1 = __importDefault(require("adp-react-icons/lib/fa/arrow-circle-left"));
var chevron_down_1 = __importDefault(require("adp-react-icons/lib/fa/chevron-down"));
var Header = /** @class */function (_super) {
  __extends(Header, _super);
  function Header() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  Header.prototype.render = function () {
    var _a = this.props,
      messages = _a.messages,
      label = _a.label,
      labelId = _a.labelId,
      onMoveRight = _a.onMoveRight,
      onMoveLeft = _a.onMoveLeft,
      onViewChange = _a.onViewChange,
      prevDisabled = _a.prevDisabled,
      upDisabled = _a.upDisabled,
      nextDisabled = _a.nextDisabled;
    return react_1.default.createElement("div", {
      className: vdl_prefix_1.vdlPrefix('calendar__header')
    }, react_1.default.createElement("button", {
      className: classnames_1.classNames(vdl_prefix_1.vdlPrefix('calendar__header__button'), vdl_prefix_1.vdlPrefix('calendar__header__button--prev')),
      tabIndex: -1,
      onClick: onMoveLeft,
      disabled: prevDisabled,
      "aria-disabled": prevDisabled,
      "aria-label": messages.moveBack,
      title: messages.moveBack
    }, react_1.default.createElement(arrow_circle_left_1.default, {
      "aria-hidden": "false"
    })), react_1.default.createElement("button", {
      id: labelId,
      tabIndex: -1,
      className: classnames_1.classNames(vdl_prefix_1.vdlPrefix('calendar__header__button'), vdl_prefix_1.vdlPrefix('calendar__header__button--view')),
      disabled: upDisabled,
      "aria-disabled": upDisabled,
      "aria-live": "polite",
      "aria-atomic": "true",
      onClick: onViewChange
    }, label, react_1.default.createElement("span", {
      className: vdl_prefix_1.vdlPrefix('calendar__header__view-icon')
    }, react_1.default.createElement(chevron_down_1.default, null))), react_1.default.createElement("button", {
      className: classnames_1.classNames(vdl_prefix_1.vdlPrefix('calendar__header__button'), vdl_prefix_1.vdlPrefix('calendar__header__button--next')),
      tabIndex: -1,
      onClick: onMoveRight,
      disabled: nextDisabled,
      title: messages.moveForward,
      "aria-label": messages.moveForward,
      "aria-disabled": nextDisabled
    }, react_1.default.createElement(arrow_circle_right_1.default, {
      "aria-hidden": "false"
    })));
  };
  Header.propTypes = {
    label: prop_types_1.default.string.isRequired,
    labelId: prop_types_1.default.string,
    upDisabled: prop_types_1.default.bool.isRequired,
    prevDisabled: prop_types_1.default.bool.isRequired,
    nextDisabled: prop_types_1.default.bool.isRequired,
    onViewChange: prop_types_1.default.func.isRequired,
    onMoveLeft: prop_types_1.default.func.isRequired,
    onMoveRight: prop_types_1.default.func.isRequired,
    messages: prop_types_1.default.shape({
      moveBack: prop_types_1.default.string,
      moveForward: prop_types_1.default.string
    })
  };
  Header.defaultProps = {
    label: '',
    upDisabled: false,
    prevDisabled: false,
    nextDisabled: false,
    onViewChange: function onViewChange() {},
    onMoveLeft: function onMoveLeft() {},
    onMoveRight: function onMoveRight() {}
  };
  return Header;
}(react_1.default.PureComponent);
exports.Header = Header;